'use client';
import { jsx as c } from "react/jsx-runtime";
import * as r from "react";
import { useInheritDocDirection as R } from "@tameeni/shared-logic";
import { selectionInputVariants as l } from "./selection-input.variants.js";
import * as s from "@radix-ui/react-toggle-group";
const f = r.createContext({
  size: "default",
  isInvalid: !1,
  direction: "horizontal"
}), v = r.forwardRef(
  ({
    children: n,
    className: a,
    onValueChange: t,
    size: e = "default",
    isInvalid: o = !1,
    direction: i = "horizontal",
    shouldForceSelection: p = !1,
    locale: u,
    ...m
  }, I) => {
    const { groupRoot: x } = l({
      direction: i,
      size: e
    }), { direction: N } = R({ locale: u });
    return /* @__PURE__ */ c(
      s.Root,
      {
        ref: I,
        className: x({ className: a }),
        ...m,
        onValueChange: (d) => {
          !d && p || t == null || t(d);
        },
        dir: m.dir || N,
        children: /* @__PURE__ */ c(f.Provider, { value: { direction: i, size: e, isInvalid: o }, children: n })
      }
    );
  }
);
v.displayName = s.Root.displayName;
const y = r.forwardRef(({ className: n, children: a, ...t }, e) => {
  const o = r.useContext(f), { item: i } = l({
    direction: o.direction,
    size: o.size,
    isInvalid: o.isInvalid
  });
  return /* @__PURE__ */ c(
    s.Item,
    {
      ref: e,
      className: i({ className: n }),
      ...t,
      children: a
    }
  );
});
y.displayName = s.Item.displayName;
export {
  v as SelectionInput,
  y as SelectionInputItem
};
